import { render, staticRenderFns } from "./ButtonFileInput.vue?vue&type=template&id=ac0587da&scoped=true&"
import script from "./ButtonFileInput.vue?vue&type=script&lang=ts&"
export * from "./ButtonFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonFileInput.vue?vue&type=style&index=0&id=ac0587da&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0587da",
  null
  
)

export default component.exports